// TODO: Rename this component. Now that it can handle more
// than just a photo, PhotoTitleSection no longer makes sense.

import React from 'react';
import styled from 'styled-components';

import { H1 as Title } from './H1';

const PhotoTitleSectionWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 9fr auto;
  margin-bottom: 60px;

  &:before {
    display: block;
    position: absolute;
    right: 0;
    ${p => (p.position === 'top' ? 'top:0;' : 'bottom:0;')}
    height: 30px;
    width: 30px;
    content: ' ';
    background: #fff;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;

    &:before {
      display: none;
    }
  }
`;

const PhotoTitleTextWrapper = styled.div`
  align-items: ${p => (p.position === 'top' ? 'flex-start' : 'flex-end')};
  display: flex;
  flex: 1;
  width: 100%;

  h1 {
    color: #2e1c1a; // TODO: Update this with variable
    font-weight: normal;
    margin: 0;
  }
`;

const PhotoTitleBody = styled.div`
  background-color: var(--nude-200);
  color: #2e1c1a; // TODO: Update this with variable
  padding: 30px;
  width: 100%;
`;

const PhotoTitlePretitle = styled.div`
  text-transform: uppercase;
  margin-bottom: 12px;
  font-size: 18px;
`;

const ElementWrapper = styled.div`
  background: var(--nude-200);
  width: 100%;
  max-width: 400px;
`;

const PhotoTitleImg = styled.img`
  transform: translate(0, 0px);
  display: block;
  margin: ${p => (p.position === 'top' ? '30px 0 0 0' : '0 0 30px 0')};
  max-width: 100%;
`;

const PhotoTitleChildrenWrapper = styled.div`
  margin-top: 24px;
`;

export const PhotoTitleSection = ({
  title,
  img,
  element,
  children,
  pretitle = false,
  position = 'bottom',
}) => {
  return (
    <PhotoTitleSectionWrapper position={position}>
      <PhotoTitleTextWrapper position={position}>
        <PhotoTitleBody>
          {pretitle && (
            <PhotoTitlePretitle style={{ textTransform: 'uppercase' }}>
              {pretitle}
            </PhotoTitlePretitle>
          )}
          <Title>{title}</Title>
          {children && (
            <PhotoTitleChildrenWrapper>{children}</PhotoTitleChildrenWrapper>
          )}
        </PhotoTitleBody>
      </PhotoTitleTextWrapper>
      <ElementWrapper>
        {img && <PhotoTitleImg src={img} position={position} />}
        {element}
      </ElementWrapper>
    </PhotoTitleSectionWrapper>
  );
};
